import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=01b145ea&scoped=true"
import script from "./TemplateEdit.vue?vue&type=script&lang=js"
export * from "./TemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b145ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b145ea')) {
      api.createRecord('01b145ea', component.options)
    } else {
      api.reload('01b145ea', component.options)
    }
    module.hot.accept("./TemplateEdit.vue?vue&type=template&id=01b145ea&scoped=true", function () {
      api.rerender('01b145ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplateEdit.vue"
export default component.exports